import type { TriageStatus } from "@/hooks/use-baseline";

export const TRIAGE_DOT: Record<TriageStatus, string> = {
  pending: "bg-foreground/20",
  "in-review": "bg-warning",
  "in-scope": "bg-success",
  "out-of-scope": "bg-destructive",
  deferred: "bg-info",
};

export const TRIAGE_BADGE: Record<TriageStatus, { label: string; cls: string }> = {
  pending: { label: "Pending", cls: "bg-muted text-foreground/60" },
  "in-review": { label: "Review", cls: "bg-warning-bg text-warning" },
  "in-scope": { label: "In scope", cls: "bg-success-bg text-success" },
  "out-of-scope": { label: "Out of scope", cls: "bg-destructive-bg text-destructive" },
  deferred: { label: "Deferred", cls: "bg-info-bg text-info" },
};
